import React, { useState } from 'react';
import NewsSourceLink from './NewsSourceLink';
import NewsShareButton from './NewsShareButton';

const NewsQuiz = ({ quiz, source, date }) => {
  const [picked, setPicked] = useState(null);
  if (!quiz?.choices?.length) return null;
  const answered = picked !== null;
  const correct = picked === quiz.answer_index;

  return (
    <section id="quiz" className="news-card news-quiz" aria-labelledby="news-quiz-title">
      <p className="news-eyebrow">오늘의 1분 퀴즈</p>
      <h2 id="news-quiz-title" className="news-quiz-question">{quiz.question}</h2>
      <div className="news-quiz-choices">
        {quiz.choices.map((choice, index) => {
          const state = !answered
            ? ''
            : index === quiz.answer_index
              ? 'is-answer'
              : index === picked
                ? 'is-wrong'
                : 'is-dim';
          return (
            <button
              key={choice}
              type="button"
              className={`news-quiz-choice ${state}`}
              onClick={() => !answered && setPicked(index)}
              disabled={answered}
              aria-pressed={picked === index}
            >
              <span className="news-quiz-choice-no">{index + 1}</span>
              {choice}
            </button>
          );
        })}
      </div>
      {answered && (
        <div className={`news-quiz-result ${correct ? 'is-correct' : 'is-incorrect'}`} role="status">
          <strong>{correct ? '정답이에요' : `정답은 ${quiz.answer_index + 1}번이에요`}</strong>
          <p>{quiz.explanation}</p>
          <NewsSourceLink source={source} />
        </div>
      )}
      {answered && date && (
        <NewsShareButton
          target="quiz"
          title="오늘의 1분 교육 퀴즈"
          text={quiz.question}
          path={`/news/${date}#quiz`}
          buttonTitle="퀴즈 풀기"
        >
          동료 선생님께 퀴즈 내기
        </NewsShareButton>
      )}
    </section>
  );
};

export default NewsQuiz;
